/**
 * 装配体配合控制器状态转换工具。
 *
 * 文件职责：
 * 1. 提供控制器内部使用的纯数据克隆能力；
 * 2. 提供选择候选中 MateEntityRef 替换能力；
 * 3. 避免控制器类堆积无副作用的数据整理函数。
 */

import type { ComponentInstanceSnapshot } from '../../component-instance';
import type { MateEntityRef } from '../../definition';
import type { AssemblyMateSelectionCandidate } from '../../selection';

/**
 * 克隆组件实例快照。
 *
 * @param snapshot 源快照。
 * @returns 快照副本。
 */
export function cloneAssemblyMateComponentInstanceSnapshot(
  snapshot: ComponentInstanceSnapshot,
): ComponentInstanceSnapshot {
  return {
    ...snapshot,
    transform: {
      position: [...snapshot.transform.position] as readonly [number, number, number],
      quaternion: [...snapshot.transform.quaternion] as readonly [number, number, number, number],
      scale: [...snapshot.transform.scale] as readonly [number, number, number],
    },
  };
}

/**
 * 为候选实体替换配合引用。
 *
 * @param candidate 原候选。
 * @param entityRef 新实体引用。
 * @returns 替换后的候选。
 */
export function replaceAssemblyMateCandidateEntityRef(
  candidate: AssemblyMateSelectionCandidate,
  entityRef: MateEntityRef,
): AssemblyMateSelectionCandidate {
  return {
    ...candidate,
    entityRef,
    label: entityRef.label,
  };
}
